import { useContext } from "react";
import userDataContext from "./userDataContext";

const useUserData = () => {
  const context = useContext(userDataContext);

  if (!context) {
    throw new Error("useUserData must be used inside UserDataProvider");
  }

  return context;
};

export default useUserData;